import React from 'react';
import Builder from '../Builder/Section';
export var Generic = Builder({
  tagName: function tagName(props) {
    return props.TagName;
  },
  render: function render(_ref) {
    var content = _ref.content;
    return /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }
});